import { render, staticRenderFns } from "./StaticDocs.vue?vue&type=template&id=c0666c7c&scoped=true"
import script from "./StaticDocs.vue?vue&type=script&lang=js"
export * from "./StaticDocs.vue?vue&type=script&lang=js"
import style0 from "./StaticDocs.vue?vue&type=style&index=0&id=c0666c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0666c7c",
  null
  
)

export default component.exports